import { PAGINATION } from "@src/mock/data/pagination";
import { PET_LIST } from "@src/mock/data/pet";

export default {
  title: '取得會員寵物列表',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": PET_LIST,
          "pagination": PAGINATION
        }
      }
    },
  ]
}
